import { GeneStructure } from "../types/genomic";

interface EnsemblGeneResponse {
  seq_region_name: string;
  start: number;
  end: number;
  strand: number;
  Transcript: Array<{
    is_canonical: boolean;
    Exon: Array<{
      start: number;
      end: number;
    }>;
  }>;
}

export class EnsemblService {
  private static readonly BASE_URL = 'https://grch37.rest.ensembl.org';
  private static readonly HEADERS = {
    'Content-Type': 'application/json',
    'Accept': 'application/json'
  };

  static async fetchGeneStructure(geneSymbol: string): Promise<GeneStructure | null> {
    try {
      const response = await fetch(
        `${this.BASE_URL}/lookup/symbol/homo_sapiens/${geneSymbol}?expand=1`,
        { headers: this.HEADERS }
      );

      if (!response.ok) {
        return null;
      }

      const data: EnsemblGeneResponse = await response.json();
      
      // Sort exons by start position to ensure correct order
      const canonicalTranscript = data.Transcript.find(transcript => transcript.is_canonical);
      if (!canonicalTranscript) {
        throw new Error(`No canonical transcript found for ${geneSymbol}`);
      }
      const sortedExons = [...canonicalTranscript.Exon].sort((a, b) => a.start - b.start);

      return {
        name: geneSymbol,
        chromosome: data.seq_region_name,
        start: data.start,
        end: data.end,
        strand: data.strand === 1 ? '+' : '-',
        exons: sortedExons.map(exon => ({
          start: exon.start,
          end: exon.end
        }))
      };
    } catch (error) {
      console.error('Error fetching gene structure:', error);
      return null;
    }
  }
} 